<template>
    <div class="breadcrumbs" :style="`${offsetTop ? `padding-top: ${+offsetTop > 0 ? `${offsetTop}px` : '0'}` : ''}`">
        <div class="container">
            <div class="row">
                <div :class="`col-lg-${showPasswordField ? '8 mb-4 mb-lg-0' : '12'}`">
                    <template v-if="page && page !==''">
                        <div class="breadcrumbs-title">{{ page }}</div>
                        <ul class="breadcrumbs-list">
                            <li class="breadcrumbs-list__item">
                                <router-link :to="i18nLink('/')">{{ $t('home') }}</router-link>
                            </li>
                            <li class="breadcrumbs-list__item"><span>{{ page }}</span></li>
                        </ul>
                    </template>
                </div>
                <div v-if="showPasswordField" class="col-lg-4">
                    <hidden-album-form  :label="!isMobile" position="left" border-radius="0"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .breadcrumbs {
        padding: 150px 0 40px;
        background: var(--bg-secondary-color);

        &-title {
            margin-bottom: 15px;
            font-size: 2.3rem;
            line-height: 1;
            color: var(--text-color);
        }

        &-list {
            display: flex;
            align-items: center;
            margin: 0;
            padding: 0;
            list-style: none;

            &__item {
                position: relative;
                font-size: .87rem;
                font-weight: 500;
                margin-right: 7px;
                padding-right: 7px;
                line-height: 1;

                &::after {
                    position: absolute;
                    content: '';
                    width: 3px;
                    height: 3px;
                    top: 50%;
                    right: -1px;
                    border-radius: 50%;
                    transform: translateY(-50%);
                    background-color: var(--text-secondary-color);
                }

                &:last-child {
                    margin-right: 0;
                    padding-right: 0;

                    &::after {
                        content: none;
                    }
                }

                &,
                & > a {
                    color: var(--text-secondary-color);
                }

                & > a {

                    &,
                    &:hover,
                    &:focus {
                        color: var(--text-secondary-color);
                        text-decoration: none;
                    }
                }
            }
        }
    }

    body.-is-mobile {

        .breadcrumbs {
            padding: 150px 0 40px;

            &-title {
                font-size: 1.75rem;
                line-height: 1.2;
            }
        }
    }
</style>

<script>
  import breadcrumbs from 'src/mixins/breadcrumbsComponent';

  import HiddenAlbumForm from '../components/HiddenAlbumForm.vue';

  export default {
    mixins: [breadcrumbs],
    components: {
      HiddenAlbumForm,
    }
  };
</script>